import { render, staticRenderFns } from "./NewLessonResources.vue?vue&type=template&id=ed9a5d4e&scoped=true&"
import script from "./NewLessonResources.vue?vue&type=script&lang=js&"
export * from "./NewLessonResources.vue?vue&type=script&lang=js&"
import style0 from "./NewLessonResources.vue?vue&type=style&index=0&id=ed9a5d4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9a5d4e",
  null
  
)

export default component.exports